/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{ignoreConnectionErrors as e}from"../../../../core/workers/utils.js";class t{constructor(e){this._client=e,this.layerView=this._client.createInvokeProxy(""),this.container=this._client.createInvokeProxy("container"),this._eventLog=this._client.createInvokeProxy("eventLog")}onEvent(t){e(this._eventLog.onEvent(t))}}export{t as PipelineConnectionHandlers};
